<template>
    <div>
        <!-- 时间选择 -->
        <md-date-picker
            v-if="minDate"
            ref="datePicker"
            v-model="isDatePickerShow"
            type="custom"
            :min-date="minDate"
            :max-date="maxDate"
            :custom-types="['yyyy', 'MM','dd']"
            :default-date="currentDate"
            @confirm="onDatePickerConfirm"
            @initialed="onDatePickerInitialed"
            >
        </md-date-picker>
    </div>
</template>
<script>
    export default {
        props: {
            minDate: {
                default: () => {
                    const time = new Date('2018/1/1')
                    return time
                }
            }
        },
        data () {
            return {
                // minDate: new Date('2018/1/1'),
                maxDate: new Date('2020/12/12'),
                isDatePickerShow: false,
                currentDate: new Date()
            }
        },
        created(){
            const year=new Date().getFullYear();
            let currentTime=`${year}/12/12`
            this.maxDate= new Date(currentTime);
        },
        methods: {
            showPicker () {
                this.currentDate = new Date();
                this.isDatePickerShow = true;
            },
            onDatePickerConfirm () {
                var values = this.$refs.datePicker.getFormatDate('yyyy-MM-dd');
                this.$emit('getTimeValue', values)
            },
            onDatePickerInitialed () {

            }
        }

    }
</script>
